import { render } from "./Panels.vue?vue&type=template&id=31500aa6&scoped=true&lang=pug"
import script from "./Panels.vue?vue&type=script&setup=true&lang=js"
export * from "./Panels.vue?vue&type=script&setup=true&lang=js"

import "./Panels.vue?vue&type=style&index=0&id=31500aa6&lang=css&scoped=true"
import "./Panels.vue?vue&type=style&index=1&id=31500aa6&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31500aa6"]])

export default __exports__